var map = {
	"./auth.module/auth.module": [
		"./src/app/auth.module/auth.module.ts",
		"common",
		"auth.module"
	],
	"./backend-main.module/backend-main.module": [
		"./src/app/backend-main.module/backend-main.module.ts",
		"backend-main.module",
		"common"
	],
	"./kalipso-message/kalipso-message.module": [
		"./src/app/kalipso-message/kalipso-message.module.ts",
		"common",
		"kalipso-message.module"
	],
	"./landing-page.module/landing-page.module": [
		"./src/app/landing-page.module/landing-page.module.ts",
		"landing-page.module"
	],
	"./player/player.module": [
		"./src/app/player/player.module.ts",
		"common",
		"player.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main